import ManageTokenService from '@/services/ManageTokenService';

export default {
  name: 'CancelButton',

  props: {
    isNotRedirect: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    handleCancelEvent() {
      ManageTokenService.removeTokenFromStorage();
      const platformUrl = this.$store.getters['authServicesPoints/platformUrl'];
      window.location.href = platformUrl;
    },
    handleCancelClick() {
      console.log('sdfsdf');
      this.$emit('handleCancelButton');
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/Common/CancelButton/component.js